import React from "react";
import TransparentModal from "../../app/UI/Modal/TransparentModal";
import { closeModal } from "./modalActions";
import { connect } from "react-redux";

import BPCDailySalesReportSpinner from "../reports/Cachet/BPCDailySales/BPCDailySalesReportSpinner";

const actions = {
  closeModal,
};

const bpcReversalsSpinnerModal = ({ closeModal }) => {
  return (
    <TransparentModal modalHeader="Please Wait...." onClose={closeModal}>
      <BPCDailySalesReportSpinner />
    </TransparentModal>
  );
};

export default connect(null, actions)(bpcReversalsSpinnerModal);
